import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/styles';
import { isDarkMode } from '../../utils/helpers';
import colors from '../../theme/colors';
import { FONT_FAMILIES } from '../../theme/material/constants';

export const OTPInputWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '20px 0px',
}));

export const Title = styled(Typography)(() => ({
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '-0.3px',
  color: isDarkMode() ? 'rgb(140, 140, 140)' : colors.light.gray.light,
  marginBottom: '15px',
}));

export const TimerText = styled(Typography)(() => ({
  textAlign: 'center',
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: 400,
  // lineHeight: '20px',
  letterSpacing: '-0.3px',
  color: colors.light.gray.light,
  marginTop: '15px',
}));

export const InputWrapperStyle = {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  maxWidth: '320px',
  margin: '0 auto',
};

export const InputStyle = {
  padding: 0,
  width: '100%',
  height: '50px',
  borderRadius: '3px',
  border: '1px solid #DAE1E9',
  margin: '0 5px',
  fontFamily: FONT_FAMILIES.primary,
  fontSize: '22px',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '-0.44px',
};
